import { render, staticRenderFns } from "./presentation-notes.vue?vue&type=template&id=be8a7aec&"
import script from "./presentation-notes.vue?vue&type=script&lang=js&"
export * from "./presentation-notes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports